import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import React, { createContext } from 'react';
import { useContextProps, Text } from 'react-aria-components';

const description = "_description_388tb_1";
const styles = {
	description: description
};

const DescriptionContext = createContext(null);
const Description = (props) => {
  const [contextProps] = useContextProps(props, null, DescriptionContext);
  const { children, isCompact } = contextProps, domProps = __rest(contextProps, ["children", "isCompact"]);
  return React.createElement(Text, Object.assign({}, domProps, { className: styles.description, "data-compact": isCompact, slot: "description", "data-zds": true }), children);
};

export { Description, DescriptionContext };
//# sourceMappingURL=Description.es.js.map
